import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api, { apiError, fmtMoney, fmtDate } from "@/lib/api";
import { PageHeader } from "@/components/shared/PageHeader";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { Loader2, Ban } from "lucide-react";
import { toast } from "sonner";

export default function StoreSales() {
  const { slug } = useParams();
  const [rows, setRows] = useState(null);
  const load = () => api.get(`/store/${slug}/sales`).then((r) => setRows(r.data)).catch(() => setRows([]));
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [slug]);

  const cancel = async (s) => {
    if (!window.confirm(`Annuler la vente ${s.number} ? Le stock sera réintégré.`)) return;
    try { await api.post(`/store/${slug}/sales/${s.id}/cancel`); toast.success("Vente annulée"); load(); }
    catch (e) { toast.error(apiError(e)); }
  };

  return (
    <div>
      <PageHeader title="Ventes" subtitle="Historique des ventes en boutique" />
      <div className="vp-card rounded-xl overflow-hidden">
        <div className="overflow-x-auto">
          <Table>
            <TableHeader><TableRow className="border-white/10 hover:bg-transparent">
              {["N°", "Date", "Vendeur", "Client", "Articles", "Montant", "Paiement", "Statut", ""].map((h) => <TableHead key={h} className="text-slate-400 text-xs uppercase tracking-wider">{h}</TableHead>)}
            </TableRow></TableHeader>
            <TableBody>
              {rows === null && <TableRow><TableCell colSpan={9} className="text-center py-10 text-slate-500"><Loader2 className="animate-spin inline mr-2" size={16} /> Chargement…</TableCell></TableRow>}
              {rows && rows.map((s) => (
                <TableRow key={s.id} className="border-white/5 hover:bg-white/[0.03]" data-testid="sale-row">
                  <TableCell className="mono text-sm text-white">{s.number}</TableCell>
                  <TableCell className="text-slate-400 text-sm">{fmtDate(s.created_at)}</TableCell>
                  <TableCell className="text-slate-300 text-sm">{s.seller}</TableCell>
                  <TableCell className="text-slate-300 text-sm">{s.customer_name}</TableCell>
                  <TableCell className="text-slate-400 text-sm mono">{s.items?.reduce((a, i) => a + i.qty, 0)}</TableCell>
                  <TableCell className="mono text-sm text-white">{fmtMoney(s.total)}</TableCell>
                  <TableCell className="text-slate-400 text-sm">{s.payment_method}</TableCell>
                  <TableCell><span className={`text-xs px-2 py-1 rounded-full ${s.status === "Annulée" ? "bg-red-500/15 text-red-400" : "bg-emerald-500/15 text-emerald-400"}`}>{s.status}</span></TableCell>
                  <TableCell>{s.status !== "Annulée" && <Button size="icon" variant="ghost" onClick={() => cancel(s)} className="h-8 w-8 text-slate-400 hover:text-red-400" data-testid="sale-cancel-btn"><Ban size={15} /></Button>}</TableCell>
                </TableRow>
              ))}
              {rows && rows.length === 0 && <TableRow><TableCell colSpan={9} className="text-center py-10 text-slate-500">Aucune vente</TableCell></TableRow>}
            </TableBody>
          </Table>
        </div>
      </div>
    </div>
  );
}
